// extracted by mini-css-extract-plugin
export default {"body":"loading_body__EFO8b","container":"loading_container__9OVO7","scale":"loading_scale__D473P","loader":"loading_loader__-sCDl","rotate":"loading_rotate__d1+8L"};